import { IDeleteContaReceberByIdUseCase } from "../../../presentation/useCases/delete/delete_conta_receber_by_id_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * deleteContaReceberByIdUseCase
 */

export class DeleteContaReceberByIdUseCase implements IDeleteContaReceberByIdUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async deleteContaReceberByIds(idList: number[], tela: string): Promise<void> {
    await this.repository.deleteContasReceberByIds(idList, tela);

  }
}
